<template>
  <div class="basic_style_asset microsite as_list">
    <div class="wrapper no-footer">
      <div class="header">
        <div class="asset-type">
          <i class="bi bi-grid-1x2-fill" />
          <h6>Microsite</h6>
        </div>
      </div>
      <h2>{{ asset_list.title }}</h2>
      <div class="footer mt-3">
        <b-badge class="mr-2" pill variant="primary">{{ asset_list.item_count }}</b-badge>
        <span>Assets</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: ['asset_list'],
  computed: {},
}
</script>

<style lang="sass" scoped>
// this is copied from bootstrap, we have it here so we dont have to include
// the full bootstrap css on the website
.badge
  display: inline-block
  background-color: var(--uePurple)
  font-size: 75%
  font-weight: 700
  line-height: 1
  text-align: center
  white-space: nowrap
  vertical-align: baseline
  padding: 0.25em 0.6em
  border-radius: 10rem
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out
.footer
  display: flex
  align-items: center
  span
    font-size: 14px
</style>
